export default function CheckIcon({ className }: { className?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" className={className}>
      <path d="M378-222 130-470l68-68 180 180 383-383 68 68-451 451Z" />
    </svg>
  );
}
